import { Component, inject } from '@angular/core';

import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SpinnerService } from '../../../services/spinner.service';

@Component({
  selector: 'app-spinner',
  imports: [ProgressSpinnerModule],
  templateUrl: './spinner.html',
  styleUrls: ['./spinner.scss'],
})
export class Spinner {
  public spinnerService = inject(SpinnerService);
}
